export default __webpack_public_path__ + "static/media/colorSplotchTrial.3b742409.svg";